import { useQuery } from "@apollo/client";
import { Avatar, Box, Center, Flex, Heading, HStack, SimpleGrid, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { Fragment } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import Filter from "../components/ClassCategories/Filter";
import LoggedInActionLinks from "../components/Classes/ActionLinks";
import { NetworkError } from "../components/UI/Error";
import Empty from "../components/UI/Errors/Empty";
import Loader from "../components/UI/Loader";
import UserLayoutv2 from "../components/UserLayoutv2";
import { GET_CLASSES_FOR_DISCOVER } from "../graphql/queries/Discover";
import { authData, filterData } from "../State";

const Discover = () => {
  const router = useRouter();

  // Recoil
  const { loggedIn, studentData } = useRecoilValue(authData);
  // const filterBy = useRecoilValue(filterData);
  const [filterBy, setFilterData] = useRecoilState(filterData);

  // discover
  const { loading, error, data } = useQuery(GET_CLASSES_FOR_DISCOVER, {
    fetchPolicy: "cache-first",
    onError: () => {
      return null;
    },
  });
  const classesData = data ? data.discover.edges : {};

  let allIndustryList = [];

  let filteredData;

  if (classesData.length > 0 && !loading) {
    classesData.forEach((singleClass) => {
      if (singleClass && singleClass.lessons.length > 0) {
        allIndustryList.push(singleClass.class_industry);
      }
    });

    // filter
    if (filterBy && filterBy.value === "All") {
      filteredData = classesData;
    } else {
      if (filterBy.checked === false) {
        setFilterData({
          value: "All",
          checked: true,
        });
      } else {
        filteredData = classesData.filter((data) => {
          return data.class_industry === filterBy.value;
        });
      }
    }
  }

  const dataToMap = filteredData || classesData;

  return (
    <UserLayoutv2
      title="Discover"
      customLeftWidth={{ base: "0%", lg: "20%" }}
      left={
        <Fragment>
          {loggedIn ? (
            <LoggedInActionLinks classesData={studentData.joined_classes} />
          ) : (
            <Box h="100%" py={10}>
              <Filter industries={allIndustryList} pl={12} />
            </Box>
          )}
        </Fragment>
      }
      customMainWidth={loggedIn ? { base: "100%", lg: "60%" } : { base: "100%", lg: "80%" }}
      main={
        <Box py={loggedIn ? { base: 8, md: 12 } : { base: 8 }} px={{ base: 6, lg: 16 }} h="100%" w="100%">
          {loading && (
            <Center minH="70vh">
              <Loader />
            </Center>
          )}

          {/* {data && <ClassCategories classesData={filteredData || CombinedData} />} */}

          {dataToMap && dataToMap.length > 0 && (
            <Box w="100%">
              <Heading as="h1" fontSize="20px" mb={5} fontWeight={700} color="blue.500">
                Discover Classes
              </Heading>

              <SimpleGrid
                w="100%"
                // columns={loggedIn ? [1, 2] : [1, 2, 3]}
                columns={loggedIn ? { base: 1, md: 2 } : { base: 1, md: 2, lg: 3 }}
                spacing="10px"
                mb={8}>
                {dataToMap &&
                  dataToMap.length > 0 &&
                  dataToMap.map((singleClass) => {
                    const author = singleClass && singleClass.created_by;
                    const title = singleClass && singleClass.class_name.substring(0, 45);
                    const cutAway = title.substring(0, 45);

                    // if (singleClass && singleClass.lessons.length > 0) {
                    return (
                      <Link passHref href={`/c/${singleClass.class_code}`}>
                        <Flex
                          as="a"
                          px={6}
                          py={8}
                          transition="all .3s ease"
                          _hover={{ boxShadow: "sm" }}
                          flexDir="column"
                          cursor="pointer"
                          h="310px"
                          border="1.5px solid"
                          borderColor="gray.100"
                          borderRadius="md">
                          <Flex w="100%" mb={16}>
                            <Avatar
                              src={author && author.avatar}
                              name={author && author.full_name}
                              w="40px"
                              h="40px"
                              size="sm"
                              fontWeight={700}
                              my="auto"
                              mr={2}
                              borderRadius="lg"
                            />
                            <Text isTruncated fontSize="lg" fontWeight="bold" my="auto">
                              {author && author.full_name}
                            </Text>
                          </Flex>

                          <Heading mb={8} fontSize="18px" lineHeight="28.8px" fontWeight={700} color="gray.500">
                            {title.length > 45 && <>{cutAway}...</>}
                            {title.length < 45 && <>{title}</>}
                          </Heading>

                          <HStack fontSize="sm" mt="auto" justifyContent="space-between" fontWeight="700" color="gray.500">
                            <Text>
                              {singleClass && singleClass.lessons.length}{" "}
                              {singleClass && singleClass.lessons.length === 1 ? "lesson" : "lessons"}
                            </Text>
                            <Text>{singleClass && singleClass.no_of_students} Enrolled</Text>
                          </HStack>
                        </Flex>
                      </Link>
                    );
                    // }
                  })}
              </SimpleGrid>
            </Box>
          )}

          {classesData && classesData.length === 0 && (
            <Center>
              <Empty py={0} title="No Classes Available" />
            </Center>
          )}

          {error && (
            <Center h="100%">
              <NetworkError description={error && error.message} />
            </Center>
          )}
        </Box>
      }
      customRightWidth={loggedIn ? { base: "0%", lg: "20%" } : "0"}
      right={
        <Box d={loggedIn ? { base: "none", lg: "block" } : "none"} h="100%" pt={10} pl={6}>
          <Filter industries={allIndustryList} />
        </Box>
      }
    />
  );
};

export default Discover;
